import React, { useContext } from 'react';
import styles from './WidgetShell.module.css';
import ThemeContext from 'config/context/themeContext';

const WidgetShell = ({ children, title, icon, colSpan }) => {
    const { dark } = useContext(ThemeContext);
    return (
        <div className={`${styles.widget_shell} ${dark ? styles.dark : ""}`} style={{gridColumn: `span ${colSpan}`}}>
            {title && <div className={styles.widget_header}>
                <h3>{title}</h3>
                {icon ? icon : <div className={styles.widget_header_indicator} style={{ backgroundColor: "#37A0F6" }} />}
            </div>}
            {children}
        </div>
    )
}

export default WidgetShell;